import Axios from './index'

/**主题 */
const getThemeList = params => Axios.get('/policy/get_theme_list', {params});
// const createTheme = params => Axios.post('/blackWhiteList/updateGroupDefault', params);
const changeTheme = params => Axios.post('/policy/change_theme', params);
const deleteTheme = params => Axios.post('/policy/delete_theme', params);


/**政策库首页 */
const getPolicyByOrg = params => Axios.post('/policy/get_policy_by_org', params);
const getRecommendSearch = params => Axios.post('/policy/get_recommend_search', params);
const getPopularLatestPolicy = params => Axios.post('/policy/get_popular_latest_policy', params);
const getOrgAndNum = params => Axios.post('/policy/get_org_and_num', params);

/**政策检索 */
const createSearch = params => Axios.post('/policy/create_search', params);
const getNewestSearch = params => Axios.get('/policy/get_newest_search', {params});
const getFullPolicy = params => Axios.post('/policy/get_full_policy', params);
const getPolicyTimelineMindmap = params => Axios.post('/policy/policy_timeline&mind_map', params);
const getPolicyTimeline = params => Axios.post('/policy/policy_timeline', params);
const getPolicyExtendKeywords = params => Axios.post('/policy/keywords_extend', params);
const getPdf = params => Axios.post('/policy/get_pdf', params, {responseType: 'blob'});
const getWordCloud = params => Axios.post('/policy/get_word_cloud', params);

/**政策问答 */
const policyQA = params => Axios.post('/policy/qa', params);
const getHistoryQA = params => Axios.get('/policy/get_history_qa', {params});

/**布鲁金斯检索 */
const brookingsSearch = params => Axios.post('/brookings/search', params);
const getBrookingsArticle = params => Axios.post('/brookings/get_article', params);
const translate = params => Axios.post('/google_translate', params);

/**微信搜索 */
const weixinSearch = params => Axios.post('/policy/weixin_search', params);

/** 海外智库 */
const developSearch = params => Axios.post('/development_research_center/search', params);
const getDevelopmentResearchCenterArticle = params => Axios.post('/development_research_center/get_article', params);

const kdiSearch = params => Axios.post('/kdi/search', params);
const getKdiArticle = params => Axios.post('/kdi/get_article', params);

/** 收藏夹 */
const getSavedFoldList = params => Axios.post('/policy/get_saved_fold_list', params);
const createSavedFold = params => Axios.post('/policy/create_saved_fold', params);
const saveContent = params => Axios.post('/policy/save_content', params);
const getSavedContent = params => Axios.post('/policy/get_saved_content', params);
const deleteSavedFold = params => Axios.post('/policy/delete_saved_fold', params);
const deleteSavedContent = params => Axios.post('/policy/delete_saved_content', params);
const updateSavedFoldInfo = params => Axios.post('/policy/update_saved_fold_info', params);


/**海外智库全量搜索 */
const thinktankSearch = params => Axios.post('/policy/think_tank_search', params);
const getThinktankContent = params => Axios.post('/policy/get_think_tank_content', params);

/** 快速搜索 */
const createSearchFast = params => Axios.post('/policy/create_search_fast_es', params);

/** 政策解读 */
const getPolicyJiedu = params => Axios.post('/policy/get_policy_jiedu', params);

/** 政策变迁 */
const getPolicyChange = async (params, onProgress) => {
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'text/event-stream',
  };

  // 添加Authorization header（如果不是grid-build环境）
  if (process.env.REACT_APP_TYPE !== 'grid-build') {
    headers['Authorization'] = `Bearer ${process.env.REACT_APP_AUTHORIZATION_TOKEN}`;
  }

  const response = await fetch(process.env.REACT_APP_COMPARE_URL, {
    method: 'POST',
    headers,
    body: JSON.stringify(params)
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  try {
    while (true) {
      const { done, value } = await reader.read();

      if (done) {
        break;
      }

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');

      // 保留最后一行（可能不完整）
      buffer = lines.pop() || '';

      for (const line of lines) {
        if (line.startsWith('data: ')) {
          const data = line.slice(6).trim();

          if (data === '[DONE]') {
            onProgress?.({ type: 'complete' });
            return;
          }

          try {
            const parsed = JSON.parse(data);

            // OpenAI 格式的流式响应
            if (parsed.choices && parsed.choices[0]) {
              const delta = parsed.choices[0].delta;

              if (delta.content) {
                onProgress?.({
                  type: 'llm',
                  value: delta.content
                });
              }

              if (delta.reasoning) {
                onProgress?.({
                  type: 'think',
                  value: delta.reasoning
                });
              }
            }
          } catch (parseError) {
            console.error('解析流式数据错误:', parseError, '原始数据:', data);
          }
        }
      }
    }
  } finally {
    reader.releaseLock();
  }
};

export{
    getPdf,
    getOrgAndNum,
    getPolicyByOrg,
    getRecommendSearch,
    getPopularLatestPolicy,
    thinktankSearch,
    getThinktankContent,
    getThemeList,
    getPolicyTimelineMindmap,
    getPolicyTimeline,
    getPolicyExtendKeywords,
    getWordCloud,
    // createTheme,
    changeTheme,
    deleteTheme,
    createSearch,
    getNewestSearch,
    getFullPolicy,
    policyQA,
    getHistoryQA,
    brookingsSearch,
    getBrookingsArticle,
    weixinSearch,
    translate,
    developSearch,
    kdiSearch,
    getDevelopmentResearchCenterArticle,
    getKdiArticle,
    getSavedFoldList,
    createSavedFold,
    saveContent,
    getSavedContent,
    deleteSavedFold,
    deleteSavedContent,
    updateSavedFoldInfo,
    createSearchFast,
    getPolicyJiedu,
    getPolicyChange
}